// @flow
export const ROUTE: {
    AUTH: 'auth',
    COMMON: 'common',
    DASHBOARD: 'dashboard',
    DOCUMENTS: 'documents',
    LICENSE: 'license-list',
    SETTINGS: 'settings',
    STYLE_GUIDE: 'style-guide',
    TRAINING_MODULE: 'training-modules',
    USERS: 'user-list',
} = {
    AUTH: 'auth',
    COMMON: 'common',
    DASHBOARD: 'dashboard',
    DOCUMENTS: 'documents',
    LICENSE: 'license-list',
    SETTINGS: 'settings',
    STYLE_GUIDE: 'style-guide',
    TRAINING_MODULE: 'training-modules',
    USERS: 'user-list',
};
